






























import { Component, Vue } from "vue-property-decorator";
import { Console, Events } from "@/common/global.ts";

import BasePage from "@/common/base-page.ts";

import UIHeaderBasic from "@/views/ui/HeaderBasic.vue";
import UIFooter from "@/views/ui/Footer.vue";
import UINavigation from "@/views/ui/Navigation.vue";

@Component({
    components: {
        UIHeaderBasic,
        UIFooter,
        UINavigation,
    },
})
export default class Video extends BasePage {

}
